<template>
  <section>
    <HomePageSwitcher @setActiveTab="setActiveTab" />
    <template>
      <b-overlay
        :show="branchesIsLoadingOverlay"
        rounded="sm"
        :class="{ 'mb-5': isMobile }"
      >
        <VueSlickCarousel
          :arrows="false"
          :dots="true"
          :key="featureBannerLength"
          :autoplay="true"
          :speed="5000"
          :autoplaySpeed="5000"
        >
          <template v-if="subdomain == 'carmens-best'">
            <div class="banner-content">
              <img
                src="@/assets/images/carmens.jpg"
                alt="Banner"
                class="mx-auto img-fluid"
              />
            </div>
          </template>
          <template v-else-if="subdomain == 'bistrobff'">
            <div class="banner-content">
              <img
                src="@/assets/images/TGIF.jpg"
                alt="Banner"
                class="mx-auto img-fluid"
              />
            </div>
          </template>
          <template v-else>
            <template
              v-if="
                featureBanner != null &&
                featureBanner.feature_banner.length != 0
              "
            >
              <div
                v-for="(banner, index) in featureBanner.feature_banner"
                :key="index"
              >
                <template v-if="banner.url_link != ''">
                  <template
                    v-if="
                      banner.url_link.includes('http://') ||
                      banner.url_link.includes('https://')
                    "
                  >
                    <a :href="banner.url_link" target="_blank">
                      <div class="banner-content">
                        <img
                          :src="banner.web_image"
                          alt="Banner"
                          class="mx-auto img-fluid"
                        />
                      </div>
                    </a>
                  </template>
                  <template v-else>
                    <a :href="'http://' + banner.url_link" target="_blank">
                      <div class="banner-content">
                        <img
                          :src="banner.web_image"
                          alt="Banner"
                          class="mx-auto img-fluid"
                        />
                      </div>
                    </a>
                  </template>
                </template>
                <template v-else>
                  <div class="banner-content">
                    <img
                      :src="banner.web_image"
                      alt="Banner"
                      class="mx-auto img-fluid"
                    />
                  </div>
                </template>
              </div>
            </template>
            <template v-else>
              <div
                class="banner-content"
                :style="{
                  backgroundImage:
                    'url(' + require('../assets/images/blank-banner.png') + ')',
                }"
              ></div>
            </template>
          </template>
        </VueSlickCarousel>
      </b-overlay>
      <template v-for="(section, index) in homeWebLayoutOrder">
        <About :key="`section_${index}`" v-if="!isLoadingHomeWebLayout && section === 'about_us' && activeTab === 'Home' && homeWebLayout['about_us.enable']" />
        <Categories :key="`section_${index}`" v-if="!isLoadingHomeWebLayout && section === 'categories' && activeTab === 'Home' && homeWebLayout['categories.enable']" />
        <Brands :key="`section_${index}`" v-if="!isLoadingHomeWebLayout && section === 'our_brands' && activeTab === 'Home' && homeWebLayout['our_brands.enable']" />
        <div :key="`section_${index}`" v-if="!isLoadingHomeWebLayout && section === 'whats_nearby' && homeWebLayout['whats_nearby.enable']">
          <div class="tab-nav-home mt-3 mb-3" v-if="isEstoreTopUp && activeTab === 'Home'">
            <div class="container">
              <b-tabs content-class="mt-3">
                <div class="mt-3 mb-3" id="estore">
                  <h2 class="sub-header-text" v-if="activeTab === 'Home' && location">What's Nearby</h2>
                  <template v-if="!location">
                    <WhatsNearbyInputAddress
                      @setPlace="setPlace"
                      :cart="cart"
                    />
                  </template>

                  <b-overlay :show="estoreIsLoadingOverlay" rounded="sm">
                    <div
                      class="row store-content mt-33 mb-5"
                    >
                      <template v-if="branchesNearby != null && location">
                        <template v-if="branchesNearby.length >= 1">
                          <div
                            class="col-md-6 col-lg-4"
                            v-for="(branch, index) in branchesNearby"
                            v-bind:key="index"
                          >
                            <div
                              class="store-content-item"
                              @click="
                                goToStore(
                                  subdomain,
                                  branch.uuid,
                                  branch.brand_uuid
                                )
                              "
                            >
                              <div
                                v-if="branch.use_brand_logo === false"
                                :class="[
                                  'store-content-item-img',
                                  {
                                    'temp-closed':
                                      branch.temporary_closed ||
                                      !branch.is_open,
                                    'cut-off-time':
                                      branch.cut_off_time &&
                                      !branch.temporary_closed &&
                                      branch.is_open,
                                  },
                                ]"
                                :style="{
                                  backgroundImage:
                                    'url(' + branch.branch_image + ')',
                                }"
                              >
                                <span
                                  v-if="
                                    branch.cut_off_time &&
                                    !branch.temporary_closed &&
                                    branch.is_open
                                  "
                                  class="cut-off-warning-wrapper"
                                  >Orders must be placed before
                                  {{
                                    transformBranchCutOffTime(
                                      branch.cut_off_time
                                    )
                                  }}
                                  today</span
                                >
                              </div>
                              <div
                                v-else
                                :class="[
                                  'store-content-item-img',
                                  {
                                    'temp-closed':
                                      branch.temporary_closed ||
                                      !branch.is_open,
                                    'cut-off-time':
                                      branch.cut_off_time &&
                                      !branch.temporary_closed &&
                                      branch.is_open,
                                  },
                                ]"
                                :style="{
                                  backgroundImage:
                                    'url(' + branch.brand_image + ')',
                                }"
                              >
                                <span
                                  v-if="
                                    branch.cut_off_time &&
                                    !branch.temporary_closed &&
                                    branch.is_open
                                  "
                                  class="cut-off-warning-wrapper"
                                  >Orders must be placed before
                                  {{
                                    transformBranchCutOffTime(
                                      branch.cut_off_time
                                    )
                                  }}
                                  today</span
                                >
                              </div>
                              <h3
                                :class="[
                                  'store-content-item-title',
                                  {
                                    'temp-closed':
                                      branch.temporary_closed ||
                                      !branch.is_open,
                                  },
                                ]"
                              >
                                {{ branch.brand_name }} ({{ branch.name }})
                              </h3>
                              <p
                                :class="[
                                  'store-content-item-subtext text-truncate',
                                  {
                                    'temp-closed':
                                      branch.temporary_closed ||
                                      !branch.is_open,
                                  },
                                ]"
                              >
                                <template
                                  v-for="(category, index) in branch.categories"
                                >
                                  <template
                                    v-if="branch.categories.length - 1 != index"
                                  >
                                    {{ category.name + ", " }}
                                  </template>
                                  <template v-else>
                                    {{ category.name }}
                                  </template>
                                </template>
                              </p>
                              <div
                                :class="[
                                  'store-content-item-desc',
                                  {
                                    'temp-closed':
                                      branch.temporary_closed ||
                                      !branch.is_open,
                                  },
                                ]"
                              >
                                <template v-if="branch.distance">
                                  <span class="distance">{{ branch.distance.toFixed(1) }} km</span>
                                  <span class="separator"></span>
                                </template>
                                <template v-if="branch.temporary_closed">
                                  <span class="clrRed fw-bold">Temporarily Closed</span>
                                </template>
                                <template v-else>
                                  <template v-if="branch.is_open">
                                    <span class="clrGreen fw-bold">Open</span>
                                  </template>
                                  <template v-else>
                                    <span class="clrRed fw-bold">Closed</span>
                                  </template>
                                </template>
                              </div>
                            </div>
                          </div>
                        </template>
                        <template v-else>
                          <div class="col-12">
                            <div class="empty-nearby-options text-center">
                              <img
                                src="@/assets/images/empty-nearby-options.png"
                                alt="No nearby options"
                              />
                              <h2 class="mb-4">Sorry!</h2>
                              <p class="mb-0">
                                Your location does not have any nearby options.
                              </p>
                              <p>
                                Let's try another
                                <strong
                                  v-if="
                                    webDesign !== null &&
                                    webDesign.design !== null
                                  "
                                  class="text-primary"
                                  :style="{
                                    color:
                                      webDesign.design.main_color +
                                      '!important',
                                  }"
                                  @click="triggerSearchLocation"
                                >
                                  location search
                                </strong>
                                <strong
                                  v-else
                                  class="text-primary"
                                  @click="triggerSearchLocation"
                                >
                                  location search
                                </strong>
                              </p>
                            </div>
                          </div>
                        </template>
                      </template>
                    </div>
                  </b-overlay>
                </div>
              </b-tabs>
            </div>
          </div>
        </div>
      </template>
      <template v-if="isEstoreTopUp && activeTab === 'EStore'">
        <div class="tab-nav-home mt-3 mb-3">
          <div class="container">
            <b-tabs content-class="mt-3">
              <div class="mt-3 mb-3" id="estore">
                <template v-if="!location">
                  <WhatsNearbyInputAddress
                    @setPlace="setPlace"
                    :cart="cart"
                  />
                </template>

                <b-overlay :show="estoreIsLoadingOverlay" rounded="sm">
                  <div
                    class="row store-content mt-33 mb-5"
                  >
                    <template v-if="branchesNearby != null && location">
                      <template v-if="branchesNearby.length >= 1">
                        <div
                          class="col-md-6 col-lg-4"
                          v-for="(branch, index) in branchesNearby"
                          v-bind:key="index"
                        >
                          <div
                            class="store-content-item"
                            @click="
                              goToStore(
                                subdomain,
                                branch.uuid,
                                branch.brand_uuid
                              )
                            "
                          >
                            <div
                              v-if="branch.use_brand_logo === false"
                              :class="[
                                'store-content-item-img',
                                {
                                  'temp-closed':
                                    branch.temporary_closed ||
                                    !branch.is_open,
                                  'cut-off-time':
                                    branch.cut_off_time &&
                                    !branch.temporary_closed &&
                                    branch.is_open,
                                },
                              ]"
                              :style="{
                                backgroundImage:
                                  'url(' + branch.branch_image + ')',
                              }"
                            >
                              <span
                                v-if="
                                  branch.cut_off_time &&
                                  !branch.temporary_closed &&
                                  branch.is_open
                                "
                                class="cut-off-warning-wrapper"
                                >Orders must be placed before
                                {{
                                  transformBranchCutOffTime(
                                    branch.cut_off_time
                                  )
                                }}
                                today</span
                              >
                            </div>
                            <div
                              v-else
                              :class="[
                                'store-content-item-img',
                                {
                                  'temp-closed':
                                    branch.temporary_closed ||
                                    !branch.is_open,
                                  'cut-off-time':
                                    branch.cut_off_time &&
                                    !branch.temporary_closed &&
                                    branch.is_open,
                                },
                              ]"
                              :style="{
                                backgroundImage:
                                  'url(' + branch.brand_image + ')',
                              }"
                            >
                              <span
                                v-if="
                                  branch.cut_off_time &&
                                  !branch.temporary_closed &&
                                  branch.is_open
                                "
                                class="cut-off-warning-wrapper"
                                >Orders must be placed before
                                {{
                                  transformBranchCutOffTime(
                                    branch.cut_off_time
                                  )
                                }}
                                today</span
                              >
                            </div>
                            <h3
                              :class="[
                                'store-content-item-title',
                                {
                                  'temp-closed':
                                    branch.temporary_closed ||
                                    !branch.is_open,
                                },
                              ]"
                            >
                              {{ branch.brand_name }} ({{ branch.name }})
                            </h3>
                            <p
                              :class="[
                                'store-content-item-subtext text-truncate',
                                {
                                  'temp-closed':
                                    branch.temporary_closed ||
                                    !branch.is_open,
                                },
                              ]"
                            >
                              <template
                                v-for="(category, index) in branch.categories"
                              >
                                <template
                                  v-if="branch.categories.length - 1 != index"
                                >
                                  {{ category.name + ", " }}
                                </template>
                                <template v-else>
                                  {{ category.name }}
                                </template>
                              </template>
                            </p>
                            <div
                              :class="[
                                'store-content-item-desc',
                                {
                                  'temp-closed':
                                    branch.temporary_closed ||
                                    !branch.is_open,
                                },
                              ]"
                            >
                              <template v-if="branch.distance">
                                <span class="distance">{{ branch.distance.toFixed(1) }} km</span>
                                <span class="separator"></span>
                              </template>
                              <template v-if="branch.temporary_closed">
                                <span class="clrRed fw-bold">Temporarily Closed</span>
                              </template>
                              <template v-else>
                                <template v-if="branch.is_open">
                                  <span class="clrGreen fw-bold">Open</span>
                                </template>
                                <template v-else>
                                  <span class="clrRed fw-bold">Closed</span>
                                </template>
                              </template>
                            </div>
                          </div>
                        </div>
                      </template>
                      <template v-else>
                        <div class="col-12">
                          <div class="empty-nearby-options text-center">
                            <img
                              src="@/assets/images/empty-nearby-options.png"
                              alt="No nearby options"
                            />
                            <h2 class="mb-4">Sorry!</h2>
                            <p class="mb-0">
                              Your location does not have any nearby options.
                            </p>
                            <p>
                              Let's try another
                              <strong
                                v-if="
                                  webDesign !== null &&
                                  webDesign.design !== null
                                "
                                class="text-primary"
                                :style="{
                                  color:
                                    webDesign.design.main_color +
                                    '!important',
                                }"
                                @click="triggerSearchLocation"
                              >
                                location search
                              </strong>
                              <strong
                                v-else
                                class="text-primary"
                                @click="triggerSearchLocation"
                              >
                                location search
                              </strong>
                            </p>
                          </div>
                        </div>
                      </template>
                    </template>
                  </div>
                </b-overlay>
              </div>
            </b-tabs>
          </div>
        </div>
      </template>
      <template v-if="isPointsView && activeTab === 'Loyalty'">
        <div class="container loyalty-placeholder my-5 mx-auto">
          <div class="row">
            <div
              id="MEEEE3"
              :class="[
                'col-lg-4 col-xs-12 mb-3 mb-lg-0 text-center',
                {
                  'd-flex align-items-center justify-content-center pb-5':
                    subdomain === 'ucoin',
                  'd-flex align-items-center overflow-hidden':
                    subdomain === 'dunkin-donuts',
                },
              ]"
              :style="{
                height: `${
                  subdomain === 'dunkin-donuts' ? '200px' : null
                }`,
              }"
            >
              <template v-if="subdomain === 'generika'">
                <img
                  src="@/assets/images/generika_logo.jpg"
                  alt="Generika"
                />
              </template>
              <template v-else-if="subdomain === 'ucoin'">
                <img
                  src="@/assets/images/ucoin_mechanics_img.jpg"
                  alt="UCOIN"
                />
              </template>
              <template v-else-if="subdomain === 'dunkin-donuts'">
                <img
                  src="@/assets/images/dunkin_donut_logo.jpg"
                  alt="Dunkin Donuts"
                />
              </template>
              <template v-else-if="subdomain === 'frankieswings'">
                <img
                  src="@/assets/images/frankieswings.png"
                  alt="Frankies Wings"
                />
              </template>
              <template v-else-if="subdomain === 'relxclub'">
                <img
                  src="@/assets/images/relx-mechanics-img.png"
                  alt="RELX Club"
                />
              </template>
              <template v-else-if="subdomain === 'dcfecorporation'">
                <img
                  src="@/assets/images/mechanics-dcfecorporation.png"
                  alt="dcfecorporation"
                />
              </template>
              <template v-else-if="subdomain.toLowerCase() === 'cacaohubers'">
                <img
                  src="@/assets/images/points-mechanics/cacaohubers.png"
                  alt="cacaohubers"
                />
              </template>
              <template v-else-if="subdomain.toLowerCase() === 'instaezwash'">
                <img
                  src="@/assets/images/points-mechanics/instaezwash.png"
                  alt="instaezwash"
                />
              </template>
              <template v-else-if="subdomain.toLowerCase() === 'puritansprideph'">
                <img src="@/assets/images/puritanpride_logo.png" alt="puritansprideph" />
              </template>
              <template v-else>
                <div v-if="mechanics != null">
                  <img :src="mechanics.image" :alt="mechanics.title" :title="mechanics.title" />
                </div>
                <div v-else>
                  <img src="@/assets/images/sample-img1.png" alt="" />
                </div>
              </template>
            </div>
            <div class="col-xs-12 col-lg-8" id="MEEEE4">
              <div v-if="subdomain.toLowerCase() === 'puritansprideph'">
                <h4 class="mb-3">Puritan’s Perks</h4>
              </div>
              <div v-else>
                <h4 class="sub-header-text mb-3" v-if="mechanics != null">
                  {{mechanics.title}}
                </h4>
                <h4 class="sub-header-text mb-3" v-else>
                  Mechanics
                </h4>
              </div>

              <template v-if="subdomain === 'ucoin'">
                <p>
                  Welcome to U-COIN—Unilever's exclusive rewards
                  program. Get more when you buy Unilever products and
                  participate in selected activities!
                </p>
                <p>
                  How to earn? You can earn U-COINs by (1) one-time,
                  answering the U-PICK survey or (2) every time,
                  purchasing at U-STORE or any partner stores and
                  receive 1 U-COIN for every P200 purchase value.
                </p>
                <p>
                  Enjoy your rewards! With these U-COINs, you can
                  purchase amazing gifts from our partners for your
                  daily essential needs, mobile load, mobile data,
                  travel, shopping, and more!
                </p>
                <p class="mb-5">
                  REGISTER NOW and start earning U-COINs today! Get 5
                  U-COINs as a welcome gift.
                </p>
              </template>
              <template v-else-if="subdomain === 'relxclub'">
                <p class="mb-1 fw-bold">Welcome to RELX Club!</p>
                <p class="mb-1">As a member of the Club, we’d love to share with you our Loyalty Program.</p>
                <p class="mb-4">You can earn points, redeem and get your favorite RELX products.</p>

                <p class="mb-0">SHOP</p>
                <p class="mb-2 text-muted">For every P100 spend, get 1 point</p>

                <p class="mb-0">REFER FRIENDS</p>
                <p class="mb-2 text-muted">Get 10 points when they place their first order</p>

                <p class="mb-0">LIKE US ON FACEBOOK</p>
                <p class="mb-2 text-muted">Like our Facebook Page, get 20 points</p>

                <p class="mb-0">FOLLOW US ON TIKTOK</p>
                <p class="mb-2 text-muted">Follow us on Tiktok, get 20 points</p>

                <p class="mb-0">SUBSCRIBE TO OUR EMAIL</p>
                <p class="mb-2 text-muted">Subscribe to our email list, get 20 points</p>

                <p class="my-4">You can check your points by visiting <a href="https://estore.rush.ph/relxclub/" target="_blank" rel="noopener">estore.rush.ph/relxclub/</a></p>
              </template>
              <template v-else-if="subdomain === 'dcfecorporation'">
                <p>
                  Earn DCFE points every Php 1,000.00 purchase. Stay tuned to our page and watch out for special events and promos that can let you earn even more points. You can redeem your point for gift items in our catalog every quarter.
                </p>
              </template>
              <template v-else-if="subdomain.toLowerCase() === 'cacaohubers'">
                <ol>
                  <li>For every 25 pesos spent, customer earns 1 cocoa bean.</li>
                  <li>Beans cannot be earned on buying gift certificates or redeeming other vouchers.</li>
                  <li>Add on for the beverages will be paid for by the huber. 1 reward can be redeemed per transaction.</li>
                  <li>Every Huberthday (Day of registration), half of the beans will expire. Huber level will stay the same and his membership level will be set according to the number of beans remaining after 1 month.</li>
                  <li>When rewards are redeemed using beans and the remaining beans becomes below the required beans in a level, huber is given 3 months to stay on his level of membership and earn beans to reach the required beans of his current level. Otherwise, huber membership will be downgraded in accordance with his bean balance.</li>
                  <li>Rewards can be used to purchase CCH Products.</li>
                </ol>
              </template>
              <template v-else-if="subdomain.toLowerCase() === 'instaezwash'">
                <ol>
                  <li>As a thank you for availing our service, a customer gets a loyalty reward by accumulation of points.</li>
                  <li>All customers can earn points except for the following:
                    <ul>
                      <li>Pick-up & Delivery Hubs (Taguig, Manila, Cavite, and Laguna), P40 Wash Promo, discounted services, other promos and corporate sales and government contracts. </li>
                    </ul>
                  </li>
                  <li>Customer will create an account by filling up a form onsite or online. Once account is created, customer can start availing of the loyalty reward and earn points.</li>
                  <li>One (1) point is given for every PhP10.00 transaction. </li>
                  <li>The loyalty account cannot be shared with other customers. </li>
                  <li>Customer who wishes to redeem points will fill up a redemption form. Equivalent loyalty rewards promo codes will be sent via email or text message.
                    <br/>
                    Possible redemption items:
                    <ul>
                      <li>Bonus points</li>
                      <li>1-pc chicken and rice meal</li>
                      <li>Meal with toy</li>
                      <li>6-pcs chicken bucket meal</li>
                    </ul>
                  </li>
                  <li>Relatives of staff up to second degree of affinity cannot join this promo.</li>
                  <li>Offered in select shops.</li>
                  <li>Promo is valid for one (1) year from December 6, 2021, to December 6, 2022, redemption until December 31, 2022.</li>
                </ol>
              </template>
              <template v-else-if="subdomain.toLowerCase() === 'kravers'">
                <div>Enjoy 2% Cashback from Kraver's every time you complete an order!</div>
                <div class="fw-bold mt-3">
                  For every &#8369;100 spend, get 2 points!
                </div>
                <div>
                  We're giving away EXTRA 200 points for all new sign-ups, so let's go!
                </div>
                <div class="mt-3">
                  Watch your points add up to spend anything you want on our rewards catalog! Points do not expire, so enjoy them anytime you want!
                </div>
                <div class="my-3">
                  To join, just sign up with your mobile number.
                </div>
              </template>
              <template v-else-if="subdomain.toLowerCase() === 'puritansprideph'">
                <p>Welcome to your wellness rewards — perks to care for you like family.</p>
                <p>
                  You make us feel so honored with your trust, just as families choose and rely on Puritan's Pride for almost 50 years. <span class="fw-bold">Puritan's Perks</span> is our way of appreciating you, for letting us be there with you on your wellness journey. So thank you, #TeamPuritans!
                </p>
                <p>
                  <span class="fw-bold">Welcome Treats</span>
                  <ul>
                    <li>Sign up and get up to &#8369;1,000 worth of vouchers</li>
                  </ul>
                </p>
                <p>
                  <span class="fw-bold">1 Point = Every &#8369;25 Spend</span>
                  <ul>
                    <li>Earn a point for every &#8369;25 spent on our store at <a href="Puritanspride.ph" target="_blank">Puritanspride.ph</a></li>
                  </ul>
                </p>
                <p>
                  <span class="fw-bold">Choose Your Rewards</span>
                  <ul>
                    <li>Use points to redeem vouchers, bonus gifts, and more exclusives!</li>
                  </ul>
                </p>
                <p>
                  <span class="fw-bold">Enjoy Your Privileges</span>
                  <ul>
                    <li>Get more perks including Double Points Sale and birthday surprise</li>
                  </ul>
                </p>
                <p class="fw-bold">Frequently Asked Questions</p>
                <div class="mb-3">
                  <div class="fw-bold">What is Puritan's Perks?</div>
                  <div>
                    <span class="fw-bold">Puritan's Perks</span> is a loyalty program of Puritan’s Pride that treats our best customers like family.  Earn points when you shop on our website <a href="www.puritanspride.ph" target="_blank">www.puritanspride.ph</a> Use your points to redeem exclusive vouchers and more treats!
                  </div>
                </div>
                <div class="mb-3">
                  <div class="fw-bold">How can I join?</div>
                  <div>
                    Purchase Digital Cards on at <a href="www.puritanspride.ph" target="_blank">www.puritanspride.ph</a>, and you’ll receive welcome treats worth &#8369;1,549. Register at <a href="https://estore.rush.ph/PuritansPridePH/" target="_blank" rel="noopener">https://estore.rush.ph/PuritansPridePH/</a> to complete the process.
                  </div>
                </div>
                <div class="mb-3">
                  <div class="fw-bold">How can I earn points?</div>
                  <div>
                    After registration, you'll receive &#8369;100 signing bonus. Then you'll earn 1 point for every &#8369;25 purchase on our website. You can get extra points during special bonus events. Note: Crediting of points will start on registration day. Previous transactions were not included.
                  </div>
                </div>
                <div class="mb-3">
                  <div class="fw-bold">Can I earn points from my purchase on Shopee, Watsons, and Tiktok store?</div>
                  <div>
                    As of now, points are credited only from <a href="www.puritanspride.ph" target="_blank" rel="noopener">www.puritanspride.ph</a>. Don’t worry, we're making a way to include our other official stores, too. Stay tuned!
                  </div>
                </div>
                <div class="mb-3">
                  <div class="fw-bold">Do points expire?</div>
                  <div>
                    Points not redeemed will expire after one year.
                  </div>
                </div>
                <div class="mb-3">
                  <div class="fw-bold">How can I use points to redeem rewards?</div>
                  <div>
                    Go to <a href="https://estore.rush.ph/PuritansPridePH" target="_blank" rel="noopener">https://estore.rush.ph/PuritansPridePH</a> for rewards list. Use your points to redeem the rewards you select.
                  </div>
                </div>
                <div class="mb-3">
                  <div class="fw-bold">Can I use my points to buy Puritan’s Pride products?</div>
                  <div>
                    You can use points to redeem vouchers which you can use to buy Puritan's Pride supplements. Go to <a href="https://estore.rush.ph/PuritansPridePH" target="_blank" rel="noopener">https://estore.rush.ph/PuritansPridePH</a> to redeem vouchers.
                  </div>
                </div>
                <div class="mb-3">
                  <div class="fw-bold">What are my other privileges from Puritan’s Perks?</div>
                  <div>
                    Besides earning points, you'll get a birthday treat, special monthly vouchers, access to Double Points Sale, and more exclusives!
                  </div>
                </div>
              </template>
              <template v-else>
                <p v-if="mechanics != null" v-html="mechanics.description"></p>
                <p v-else>
                  Lorem ipsum dolor sit amet, consectetur adipiscing
                  elit, sed do eiusmod tempor incididunt ut labore et
                  dolore magna aliqua. Ut enim ad minim veniam, quis
                  nostrud exercitation ullamco laboris nisi ut aliquip
                  ex ea commodo consequat. Duis aute irure dolor in
                  reprehenderit in voluptate velit esse cillum dolore eu
                  fugiat nulla pariatur. Excepteur sint occaecat
                  cupidatat non proident, sunt in culpa qui officia
                  deserunt mollit anim id est laborum.
                </p>
              </template>
              <template v-if="!loggedIn">
                <div>
                  <b-link
                    :to="`/${subdomain}/login`"
                    class="btn btn-core text-uppercase mr-3 mb-3 mb-md-0"
                    v-if="webDesign !== null && webDesign.design !== null"
                    :style="{
                      backgroundColor:
                        webDesign.design.main_color + '!important',
                      border: 'none !important',
                      color:
                        webDesign.design.button_text_color + '!important',
                    }"
                    >Sign In</b-link
                  >
                  <b-link
                    :to="`/${subdomain}/login`"
                    class="btn btn-core text-uppercase mr-3 mb-3 mb-md-0"
                    v-else
                    >Sign In</b-link
                  >
                  <b-link
                    :to="`/${subdomain}/signup`"
                    v-if="webDesign !== null && webDesign.design !== null"
                    :style="{
                      backgroundColor: 'none !important',
                      border:
                        '1px solid' +
                        webDesign.design.main_color +
                        '!important',
                      color: webDesign.design.main_color + '!important',
                    }"
                    class="
                      btn
                      outline-primary
                      btn-core
                      text-uppercase
                      mb-3 mb-md-0 px-3
                    "
                    >Create an Account</b-link
                  >
                  <b-link
                    v-else
                    :to="`/${subdomain}/signup`"
                    class="
                      btn
                      outline-primary
                      btn-core
                      text-uppercase
                      mb-3 mb-md-0 px-3
                    "
                    >Create an Account</b-link
                  >
                </div>
              </template>
            </div>
          </div>
        </div>
        <div class="container mt-3 mb-3" v-if="isPointsView && activeTab === 'Loyalty' && rewards != null">
          <h2 class="sub-header-text">Available Rewards</h2>
          <button class="filter-btn d-none" type="button">
            <img src="../assets/images/ic-filter.svg" width="25px" alt="Filter" />
            Filter
          </button>
          <template v-if="rewards.length">
            <div class="row rewards-content mt-33">
              <div
                :class="['col-md-3 mb-30', { 'mx-2': isMobile }]"
                v-for="(reward, index) in rewards"
                :key="index"
                :style="{
                  'box-shadow': isMobile
                    ? '0px 0px 9.20904px rgba(0, 0, 0, 0.15)'
                    : null,
                  'border-radius': isMobile ? '9.48956px' : null,
                }"
              >
                <router-link
                  :to="'/' + subdomain + '/rewards/' + reward.uuid"
                >
                  <div class="rewards-content-item">
                    <div
                      class="rewards-content-item-img pos-rlt"
                      :style="{
                        backgroundImage: 'url(' + reward.image + ')',
                      }"
                    >
                      <div class="ribbon-small d-none">
                        <img
                          src="@/assets/images/jollibee.png"
                          alt
                          width="55%"
                        />
                      </div>
                      <span
                        v-if="reward.rewards_label != ''"
                        class="rewards-content-item-img-price teal-clr"
                      >
                        FREE
                      </span>
                    </div>
                    <h3 class="rewards-content-item-title">
                      {{ reward.name }}
                    </h3>
                    <template v-if="reward.rewards_label != ''">
                      <span class="rewards-content-item-price">
                        {{ reward.rewards_label }}
                      </span>
                    </template>
                    <template v-else>
                      <span class="rewards-content-item-price">
                        {{ putComma(reward.points) }}
                        {{
                          subdomain === "ucoin"
                            ? `U-COIN${reward.points > 1 ? "S" : ""}`
                            : "Points"
                        }}
                      </span>
                    </template>

                    <div class="mt-10 mb-20">
                      <span
                        class="rewards-content-item-tag orange-clr d-none"
                        >Health and Wellness</span
                      >
                    </div>
                  </div>
                </router-link>
              </div>
            </div>
            <b-pagination
              v-model="currentPage"
              hide-goto-end-buttons
              :total-rows="
                rewardTotalPerPage > 0
                  ? rewardMaxPage * rewardTotalPerPage
                  : 1
              "
              :limit="rewardTotalPerPage > 0 ? 5 : 1"
              :per-page="rewardTotalPerPage"
              @change="paginate"
            ></b-pagination>
          </template>
          <div v-else id="no-rewards" class="d-flex flex-column justify-content-center align-items-center">
            <img src="@/assets/images/empty-box.svg" alt="No Rewards" />
            <div id="title" class="fw-bold mt-3 mb-1">No Rewards Right Now</div>
            <div>Check back soon, exciting offers are on the way!</div>
          </div>
        </div>
      </template>
    </template>
    <b-modal ref="changeBrandBranch" title="Change Brand / Branch" hide-footer>
      <div class="modal-body aCenter">
        <p class="my-3 p-4">
          Changing brand or branch will remove all items from cart. <br />
          Would you like to continue?
        </p>
        <b-button
          type="button"
          class="btn btn-core text-uppercase mr-3"
          style="
            background-color: transparent !important;
            color: #ff8a00 !important;
            padding: 9px 70px !important;
          "
          @click="$refs.changeBrandBranch.hide()"
        >
          NO
        </b-button>
        <b-button
          type="button"
          class="btn btn-core"
          style="padding: 9px 70px !important"
          @click="emptyCart"
        >
          YES
        </b-button>
      </div>
    </b-modal>
    <b-modal
      id="popup-modal"
      centered
      hide-header
      hide-footer
      v-if="popup"
      @hide="onHidePopupModal"
    >
      <b-container>
        <b-row class="mb-2">
          <b-col class="text-center">
            <div class="d-inline-block position-relative">
              <template v-if="popup.link">
                <a :href="popup.link" target="_blank">
                  <b-img
                    :src="popup.image"
                    class="popup-image"
                    fluid
                    alt="Popup"
                  />
                </a>
                <img
                  src="@/assets/images/ic-circle-close.svg"
                  class="popup-close"
                  @click="$root.$emit('bv::hide::modal', 'popup-modal')"
                  alt="Close"
                />
              </template>
              <template v-else>
                <b-img
                  :src="popup.image"
                  class="popup-image"
                  fluid
                  alt="Popup"
                />
                <img
                  src="@/assets/images/ic-circle-close.svg"
                  class="popup-close"
                  @click="$root.$emit('bv::hide::modal', 'popup-modal')"
                  alt="Close"
                />
              </template>
            </div>
          </b-col>
        </b-row>
        <template v-if="popup.show_button">
          <b-row
            v-for="(button, index) in popup.buttons"
            :key="index"
            class="mt-2"
          >
            <b-col cols="6" md="4" class="mx-auto">
              <b-link
                :to="{
                  name:'Home'
                }"
                class="btn btn-block border-0"
                v-if="webDesign !== null && webDesign.design !== null"
                :style="{
                  color: `${button.text_color} !important`,
                  backgroundColor: `${button.color} !important`,
                }"
                @click="onPopupButtonClick"
              >
                {{ button.name }}
              </b-link>
            </b-col>
          </b-row>
        </template>
      </b-container>
    </b-modal>
  </section>
</template>

<script>
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";
import { mapState, mapGetters, mapActions } from "vuex";
import $ from "jquery";
import Categories from "@/components/layout/Categories";
import Brands from "@/components/layout/Brands";
import About from "@/components/layout/About";
import HomePageSwitcher from "@/components/layout/HomePageSwitcher";
import { gmapApi } from "vue2-google-maps";
import WhatsNearbyInputAddress from "@/components/layout/WhatsNearbyInputAddress";

export default {
  name: "Home",
  data() {
    return {
      place: null,
      currentPage: 1,
      tab: "",
      branch_uuid: null,
      brand_uuid: null,
      allow_multiple_branches: false,
      popupIndex: 0,
      isRedirecting: false,
      activeTab: "Home",
      selectedPlace: null,
      storedCoordinates: {}
    };
  },
  components: {
    VueSlickCarousel,
    // MapInPage,
    Categories,
    Brands,
    About,
    HomePageSwitcher,
    WhatsNearbyInputAddress
  },
  computed: {
    ...mapState("auth", {
      token: (state) => state.token,
      authErrors: (state) => state.errors,
      authIsLoading: (state) => state.loading,
    }),
    ...mapState("merchant", {
      subdomain: (state) => state.subdomain,
      customerPortalToken: (state) => state.customerPortalToken,
      merchantIsLoading: (state) => state.loading,
      merchantErrors: (state) => state.errors,
    }),
    ...mapState("branch", {
      branches: (state) => state.branches,
      branchesNearby: (state) => state.branchesNearby,
      branchesErrors: (state) => state.errors,
      branchesIsLoadingOverlay: (state) => state.loadingOverlay,
      branchesIsLoading: (state) => state.loading,
      coordinates: (state) => state.coordinates,
      branchesNearbyPublic: (state) => state.branchesNearbyPublic,
      featureBanner: (state) => state.featureBanner,
      featureBannerLength: (state) => state.featureBannerLength,
    }),
    ...mapState("estore", {
      cart: (state) => state.cart,
      products: (state) => state.products,
      estoreIsLoadingOverlay: (state) => state.loadingOverlay,
      estoreIsLoading: (state) => state.loading,
      estoreErrors: (state) => state.errors,
      categories: (state) => state.categories,
      webDesign: (state) => state.webDesign,
      hideMap: (state) => state.hideMap,
      storeDetails: (state) => state.storeDetails,
    }),
    ...mapState("reward", {
      rewards: (state) => state.rewards,
      rewardIsLoading: (state) => state.loading,
      rewardErrors: (state) => state.errors,
      rewardMaxPage: (state) => state.maxPage,
      rewardNextPage: (state) => state.nextPage,
      rewardPrevPage: (state) => state.prevPage,
      rewardCurrentPage: (state) => state.currentPage,
      rewardTotalPerPage: (state) => state.totalPerPage,
      rewardFirstItem: (state) => state.currentFirstItem,
      rewardLastItem: (state) => state.currentLastItem,
      rewardPageCount: (state) => state.initialPageCount,
    }),
    ...mapState("point", {
      balance: (state) => state.balance,
      pointIsLoading: (state) => state.loading,
      pointErrors: (state) => state.errors,
    }),
    ...mapState("customer", {
      location: (state) => state.location,
    }),
    ...mapState("design", {
      popup: (state) => state.popup,
    }),
    ...mapState("design", {
      popups: (state) => state.popups,
    }),
    ...mapState("page", {
      mechanics: (state) => state.mechanics,
    }),
    ...mapGetters({
      loggedIn: "auth/loggedIn",
      firstBranchNearby: "branch/firstBranchNearby",
      isEstoreTopUp: "merchant/isEstoreTopUp",
      isPointsView: "merchant/isPointsView",
      isLoadingHomeWebLayout: "design/loading",
      homeWebLayout: "design/homeWebLayout",
      cartUuid: "estore/cartUuid",
      isMobile: "isMobile/isMobile"
    }),
    popup() {
      if (!this.popups.length) return null;

      return this.popups[this.popupIndex];
    },
    getStyles() {
      return {
        "--color":
          this.webDesign !== null && this.webDesign.design !== null
            ? this.webDesign.design.main_color
            : "#ff8a00",
      };
    },
    homeWebLayoutOrder: {
      get() {
        const sectionOrder = [];
        Object.keys(this.homeWebLayout).map(key => {
          return key.includes('weight')
            ? key
            : null;
        }).filter(key => key).map(key => {
          sectionOrder[this.homeWebLayout[key]] = key.split('.')[0];
        });
        return sectionOrder.filter(section => section);
      },
      set(webLayout) {
        return webLayout;
      }
    },
    google: gmapApi
  },
  mounted() {
    window.addEventListener("resize", () => {
      this.checkStoreContentHeight(false);
    });
  },
  created: function () {
    $("body").css({ backgroundColor: "#ffffff" });
    this.tab = this.$route.query.tab;

    if (this.token) {
      Promise.all([
        this.getBranchesNearby(),
        this.getRewards(1),
        this.getFeaturedBannerList(),
        this.getPopups(),
        this.getMechanics(),
        this.getHomeLayout()
      ]).then(() => {
        this.$root.$emit("bv::show::modal", "popup-modal");
      });
    } else {
      this.getFeaturedBannerList();
      this.getBranchesNearbyPublic();
      this.getMechanics();
      this.getHomeLayout();
    }
  },
  methods: {
    ...mapActions({
      getHomeWebLayout: "design/getHomeWebLayout"
    }),
    checkStoreContentHeight(value = false) {
      const footerDiv = document.getElementById('footer-bottom');
      
      if (footerDiv)
        footerDiv.classList.remove('position-fixed');
      
      setTimeout(() => {
        if (!value) {
          const appDiv = document.getElementById('app').clientHeight;
          if (appDiv < window.innerHeight) footerDiv.classList.add('position-fixed', 'w-100');
        }
      }, 300);
    },
    onPopupButtonClick() {
      this.isRedirecting = true;
      this.$root.$emit('bv::hide::modal', 'popup-modal');
    },
    onHidePopupModal(event) {
      if (this.popupIndex < this.popups.length - 1 && !this.isRedirecting) {
        this.popupIndex++;
        event.preventDefault();
      }

      this.isRedirecting = false;
    },
    goToStore(subdomain, branch_uuid, brand_uuid) {
      this.branch_uuid = branch_uuid;
      this.brand_uuid = brand_uuid;
      const storePath = `/${subdomain}/store/${branch_uuid}&${brand_uuid}`;
      
      if (this.storeDetails) {
        if (!this.storeDetails.allow_purchase_multiple) {
          if (this.cart) {
            if (
              this.cart.cart_count > 0 &&
              this.cart.list[0].branch_uuid != branch_uuid
            ) {
              this.$refs.changeBrandBranch.show();
            } else {
              this.$router.push({ path: storePath });
            }
          } else {
            this.$router.push({ path: storePath });
          }
        } else {
          this.$router.push({ path: storePath });
        }
      } else {
        this.$router.push({ path: storePath });
      }
    },
    async emptyCart() {
      if (
        this.customerPortalToken &&
        this.cart &&
        this.cart.list.length
      ) {
        let items = [];
        const cartItems = this.cart.list[0].items;

        for (const cartItem of cartItems) {
          items.push(cartItem.uuid);
        }

        const header = {
          "X-Merchant-Token": this.customerPortalToken
        };
        const payload = {
          cart_items: items
        };

        if (this.loggedIn) {
          header["Authorization"] = this.token;
          payload.cart_count = this.cart.cart_count;
          payload.cart_total_amount = this.cart.cart_total_amount;
        } else {
          payload["cart_uuid"] = this.cartUuid;
        }

        await this.$store.dispatch(
          "estore/removeItem",
          { header, payload }
        );

        this.$store.commit("estore/SET_CART");
        this.$refs.changeBrandBranch.hide();
        this.$router.push({
          path: `/${this.subdomain}/store/${this.branch_uuid}&${this.brand_uuid}`
        });
      }
    },
    setPlace(place) {
      this.selectedPlace = place.formatted_address;
      this.storedCoordinates = {
        lat: place.geometry.location.lat(),
        long: place.geometry.location.lng(),
        distance: 8
      };
      this.$nextTick(() => {
        this.searchWhatsNearby();
      });
    },
    async getBranchesNearby() {
      if (this.coordinates != null) {
        let request = {
          header: {
            Authorization: this.token,
            "X-Merchant-Token": this.customerPortalToken,
          },
          payload: {
            latitude: this.coordinates.lat,
            longitude: this.coordinates.long,
            // distance: this.coordinates.distance
          },
        };

        if (this.loggedIn && this.customerPortalToken != null) {
          await this.$store.dispatch("branch/getBranchesNearby", request);
        }
      }
    },
    async getBranchesNearbyPublic() {
      if (
        !this.loggedIn &&
        this.customerPortalToken != null &&
        this.coordinates != null
      ) {
        let request = {
          header: {
            "X-Merchant-Token": this.customerPortalToken,
          },
          payload: {
            latitude: this.coordinates.lat,
            longitude: this.coordinates.long,
            // distance: this.coordinates.distance
          },
        };
        await this.$store.dispatch("branch/getBranchesNearbyPublic", request);
      }
    },
    async getFeaturedBannerList() {
      let request = {
        header: {
          "X-Merchant-Token": this.customerPortalToken,
        },
        payload: null,
      };

      await this.$store.dispatch("branch/getFeaturedBannerList", request);
    },
    async getRewards(page) {
      let request = {
        header: {
          Authorization: this.token,
          "X-Merchant-Token": this.customerPortalToken,
        },
        page: page,
      };
      if (this.loggedIn && this.customerPortalToken != null) {
        await this.$store.dispatch("reward/getRewards", request);
      }
    },
    paginate(page) {
      return this.getRewards(page);
    },
    putComma(number) {
      return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    triggerSearchLocation() {
      this.$root.$emit("openMap");
    },
    transformBranchCutOffTime(cutOff) {
      const splitTime = {
        hour: cutOff.split(":")[0],
        minutes: cutOff.split(":").pop(),
      };
      return this.$moment()
        .set({ hour: splitTime.hour, minute: splitTime.minutes, second: 0 })
        .format("h:mma");
    },
    async getPopups() {
      if (this.coordinates != null) {
        let request = {
          header: {
            Authorization: this.token,
            "X-Merchant-Token": this.customerPortalToken,
          },
        };
        await this.$store.dispatch("design/getPopups", request);
      }
    },
    getHomeLayout() {
      const request = {
        header: {
          "X-Merchant-Token": this.customerPortalToken
        }
      };

      this.getHomeWebLayout(request);
    },
    async getMechanics() {
      const request = {
        header: {
          "X-Merchant-Token": this.customerPortalToken
        }
      };
      await this.$store.dispatch("page/getMechanics", request);
    },
    setActiveTab(tab) {
      this.activeTab = tab;
      this.checkStoreContentHeight(false);
    },
    getCurrentLocationWhatsNearby() {
      if (navigator.geolocation) {
        this.$nextTick(() => {
          navigator.geolocation.getCurrentPosition(position => {
            if (this.google != null) {
                const formattedLatLng = new this.google.maps.LatLng(
                  parseFloat(position.coords.latitude),
                  parseFloat(position.coords.longitude)
                );

                let coordinates = {};

                coordinates = {
                  lat: position.coords.latitude,
                  long: position.coords.longitude,
                  distance: 8
                };

                this.storedCoordinates = coordinates;

                let geocoder = new this.google.maps.Geocoder();
                geocoder.geocode(
                  { latLng: formattedLatLng },
                  (result, status) => {
                    if (status === this.google.maps.GeocoderStatus.OK) {
                      this.selectedPlace = result[0].formatted_address;
                    }
                  }
                );
              }
          },
            () => {
              this.handleLocationError(true);
            }
          );
        });
        this.$forceUpdate();
      } else {
        // Browser doesn't support Geolocation
        this.handleLocationError(false);
      }
    },
    handleLocationError(browserHasGeolocation) {
      if (browserHasGeolocation) console.log("Error: The Geolocation service failed.");
      else console.log("Error: Your browser doesn't support geolocation.");
    },
    searchWhatsNearby() {
      this.$store.commit("branch/SET_COORDINATES", this.storedCoordinates);
      this.$store.commit("customer/SET_LOCATION", this.selectedPlace);
      this.$root.$emit("inPageMapSetSelectedPlace", this.selectedPlace);
    }
  },
  watch: {
    coordinates: function () {
      if (this.token != null) {
        this.getBranchesNearby();
      } else {
        this.getBranchesNearbyPublic();
      }
    },
    branchesIsLoadingOverlay(value) {
      this.checkStoreContentHeight(value);
    }
  },
};
</script>
<style scoped lang="scss">
.loyalty-placeholder {
  max-width: 1100px;
  img {
    max-width: 100%;
  }
  .btn.outline-primary {
    background-color: transparent !important;
    color: #ff8a00 !important;
  }
}
.empty-nearby-options {
  color: #66727b;
  img {
    max-width: 400px;
    width: 100%;
  }
  p {
    font-size: 17px;
    b {
      cursor: pointer;
    }
  }
}
.noLocationLoadedWrapper {
  min-height: 100vh;
}

.temp-closed,
.cut-off-time {
  &.store-content-item-img {
    width: 100%;
    display: flex;
    align-items: flex-end;
    justify-content: center;
    position: relative;
    &:not(.cut-off-time)::before {
      content: "Store Closed";
      background-color: #49545c;
      color: white;
      font-size: 14px;
      padding: 7px 14px;
      border-radius: 5px;
      z-index: 1;
      margin-bottom: 25px;
    }
    &:not(.cut-off-time)::after {
      content: "";
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      background: #c4c4c4;
      opacity: 0.5;
    }
    .cut-off-warning-wrapper {
      background-color: #49545c;
      color: white;
      font-size: 14px;
      padding: 7px 14px;
      border-radius: 5px;
      z-index: 1;
      margin-bottom: 25px;
      max-width: 200px;
      text-align: center;
    }
  }
  &.store-content-item-title,
  &.store-content-item-subtext,
  &.store-content-item-desc {
    opacity: 0.5;
  }
}
#no-rewards {
  margin-top: 57px;
  margin-bottom: 129px;
  color: #87929D;
  #title {
    font-size: 18px;
  }
}
</style>

<style lang="scss">
.slick-track {
  display: flex !important;
  align-items: center;
}
#popup-modal {
  .modal-content {
    background: transparent;
    border: 0;
    .modal-body {
      padding: 0;
    }
  }
  .popup-image {
    max-height: 80vh;
    border-radius: 15px;
  }
  .popup-close {
    width: 30px;
    position: absolute;
    top: 10px;
    right: 20px;
    cursor: pointer;
  }
}
</style>
